import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Package, Tags, Award, MessageSquare, FileText, Settings, Home, Search, Menu, Activity } from "lucide-react";

const ICONS = { product: Package, category: Tags, brand: Award, enquiry: MessageSquare, quotation: FileText, settings: Settings, homepage: Home, seo: Search, navigation: Menu };
const TYPES = ["all", "product", "category", "brand", "enquiry", "quotation", "settings", "homepage", "seo", "navigation"];
function dotColor(action) {
  if (action.startsWith("created")) return "bg-emerald-500";
  if (action.startsWith("deleted")) return "bg-red-500";
  if (action.startsWith("emailed") || action.startsWith("status")) return "bg-[#EA580C]";
  return "bg-[#0F172A]";
}

export default function AdminActivity() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("all");
  useEffect(() => { api.get("/activity", { params: type === "all" ? {} : { entity_type: type } }).then(r => setItems(r.data)); }, [type]);
  return (
    <div>
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <h1 className="font-heading font-extrabold text-2xl flex items-center gap-2"><Activity className="w-6 h-6 text-[#EA580C]"/> Activity Log</h1>
        <Select value={type} onValueChange={setType}><SelectTrigger className="w-44" data-testid="activity-filter"><SelectValue/></SelectTrigger>
          <SelectContent>{TYPES.map(t => <SelectItem key={t} value={t}>{t === "all" ? "All activity" : t}</SelectItem>)}</SelectContent></Select>
      </div>
      {items.length === 0 && <div className="text-slate-500 text-sm" data-testid="activity-empty">No activity recorded yet.</div>}
      <ol className="relative border-l-2 border-[#E2E8F0] ml-3 space-y-4 max-w-3xl" data-testid="activity-timeline">
        {items.map(a => { const I = ICONS[a.entity_type] || Activity; return (
          <li key={a.id} className="ml-6 relative" data-testid={`activity-${a.id}`}>
            <span className={`absolute -left-[31px] top-1 w-4 h-4 rounded-full ring-4 ring-white ${dotColor(a.action)}`}/>
            <div className="bg-white border border-[#E2E8F0] rounded-md p-3 flex gap-3">
              <I className="w-5 h-5 text-slate-500 shrink-0 mt-0.5"/>
              <div className="min-w-0 flex-1">
                <div className="text-sm"><span className="font-semibold capitalize">{a.entity_type}</span> <span className="text-slate-600">{a.action}</span>{a.label && <> — <span className="font-medium">{a.label}</span></>}</div>
                <div className="text-xs text-slate-500 mt-0.5">{a.user_email} · {new Date(a.created_at).toLocaleString()}</div>
              </div>
            </div>
          </li>); })}
      </ol>
    </div>
  );
}
